import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { colors } from '../styles/colors';
import { useToast } from '../contexts/ToastContext';
import { useAuth } from '../contexts/AuthContext';
import { useEffect } from 'react';

function Layout({ children }) {
  const [isCollapsed, setIsCollapsed] = React.useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });

  React.useEffect(() => {
    localStorage.setItem('sidebarCollapsed', isCollapsed);
  }, [isCollapsed]);

  // Afficher le toast de bienvenue après connexion
    const { showToast } = useToast();
    const location = useLocation();
    const { showWelcomeToast, setShowWelcomeToast, user } = useAuth(); // ✅ Déstructuration correcte
    
    useEffect(() => {
      console.log("Location state:", location.state); // ✅ Vérifie l'état
      console.log("User:", user); // ✅ Vérifie que user.prenom existe
    if (showWelcomeToast) {
      showToast(`Bienvenue ${user?.prenom || ''} !`, 'success');
      setShowWelcomeToast(false); // ✅ Réinitialise l'état
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, user, showToast]);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div style={{
      minHeight: '100vh',
      height: '100%',
      backgroundColor: colors.text.white,
      display: 'flex',
      fontFamily: '"Noto Sans", sans-serif',
      margin: 0,
      padding: 0,
      position: 'relative'
    }}>
      {/* Sidebar */}
      <Sidebar isCollapsed={isCollapsed} />

      {/* Topbar */}
      <Topbar onToggleSidebar={toggleSidebar} isCollapsed={isCollapsed} />

      {/* Contenu principal */}
      <div
        style={{
          flex: 1,
          marginLeft: isCollapsed ? '112px' : '288px',
          marginTop: '64px',
          display: 'flex',
          flexDirection: 'column',
          transition: 'margin-left 300ms ease-in-out',
          backgroundColor: colors.text.white,
          minHeight: 'calc(100vh - 64px)'
        }}
      >
        {/* Zone de contenu */}
        <main style={{
          flex: 1,
          padding: '1.5rem 1.5rem 2.5rem 1.5rem',
          margin: 0,
          overflowY: 'auto',
          minHeight: 0
        }}>
          {children}
        </main>

        {/* Footer */}
        <footer style={{
          backgroundColor: colors.text.white,
          borderTop: `1px solid ${colors.secondary.mediumGray}`,
          padding: '1rem 1.5rem',
          marginTop: 'auto',
          flexShrink: 0
        }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
            <p style={{
              textAlign: 'center',
              color: colors.secondary.mediumGray,
              fontSize: '0.875rem',
              margin: 0,
              fontFamily: '"Noto Sans", sans-serif'
            }}>
              © 2025 Nimbus - Gestion des temps et facturation
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Layout;